var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 11.8753H2.1875C1.84375 11.8753 1.5625 12.1565 1.5625 12.5003C1.5625 12.844 1.84375 13.1253 2.1875 13.1253H12.8125C13.1562 13.1253 13.4375 12.844 13.4375 12.5003C13.4375 12.1565 13.1562 11.8753 12.8125 11.8753ZM2.19375 7.25653L12.0875 9.90653C12.5875 10.0378 13.1 9.74403 13.2375 9.24403C13.3688 8.74403 13.075 8.23153 12.575 8.09403L9.25625 7.20653L7.64375 1.92528C7.575 1.70028 7.4 1.53153 7.175 1.46903C6.75 1.35653 6.33125 1.67528 6.33125 2.11903V6.41903L3.21875 5.59403L2.75 4.43153C2.675 4.25028 2.525 4.11278 2.33125 4.06278L2.125 4.00653C1.925 3.95028 1.73125 4.10028 1.73125 4.30653V6.65028C1.73125 6.93778 1.91875 7.18153 2.19375 7.25653Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightLand);
export default __webpack_public_path__ + "static/media/flight-land.7622f655fa9655a038929e34050042cf.svg";
export { ForwardRef as ReactComponent };